import { LookupSidebarPerson } from '~/components/LookupSidebar/Person';

const PersonLookup = ({ email }: { email: string }) => {
  return <LookupSidebarPerson email={email} />;
};

export default PersonLookup;
